

const labels = {
    ru: {
        paymentAction: 'Действие',
        assets: 'Актив',
        amount: 'Сумма',
        paymentStatus: 'Статус',
        bank: 'Банк',
        wallet: 'Кошелек',
        accountOrCardNumber: 'Номер счета/карты',
        comment: 'Комментарий',
        paymentIdLocal: 'ID Платежа (локальный)',
        paymentIdPlatform: 'ID Платежа (платформа)',
        leadId: 'ID Лида',
        paymentDate: 'Дата Платежа',
        createdByAdmin: 'Создано админом',
        recordCreationDate: 'Дата создания записи',
        lastUpdateDate: 'Дата последнего обновления',

        deposit: 'Депозит',
        withdraw: 'Вывод',
        bonus: 'Бонус',
        success: 'Успешно',
        process: 'В процессе',
        fail: 'Неудача',
        canceled: 'Отменено',
        waitAccept: 'Ожидает',

        editPaymentTitle: (id) => `Редактировать платеж #${id}`,
        errorLoading: "Не удалось загрузить данные платежа.",
        close: "Закрыть",
        saving: "Сохранение...",
        saveChanges: "Сохранить изменения",
        deletePayment: "Удалить платеж",
        areYouSure: "Вы уверены?",
        deleting: "Удаление...",
        yesDelete: "Да, удалить",
        noCancel: "Нет, отмена",
        cancel: "Отмена",
        infoModal: {
            id: "ID",
            firstName: "Имя",
            lastName: "Фамилия",
            email: "Email",
            role: "Роль",
            status: "Статус",
            createdAt: "Создан",
            dateAndTime: "Дата и Время",
        },
    },
    en: {
        paymentAction: 'Action',
        assets: 'Assets',
        amount: 'Amount',
        paymentStatus: 'Status',
        bank: 'Bank',
        wallet: 'Wallet',
        accountOrCardNumber: 'Account/Card Number',
        comment: 'Comment',
        paymentIdLocal: 'Payment ID (Local)',
        paymentIdPlatform: 'Payment ID (Platform)',
        leadId: 'Lead ID',
        paymentDate: 'Payment Date',
        createdByAdmin: 'Created By Admin',
        recordCreationDate: 'Record Creation Date',
        lastUpdateDate: 'Last Update Date',

        deposit: 'Deposit',
        withdraw: 'Withdraw',
        bonus: 'Bonus',
        success: 'Success',
        process: 'In Process',
        fail: 'Fail',
        canceled: 'Canceled',
        waitAccept: 'Wait Accept',

        editPaymentTitle: (id) => `Edit payment #${id}`,
        errorLoading: "Failed to load payment data.",
        close: "Close",
        saving: "Saving...",
        saveChanges: "Save changes",
        deletePayment: "Delete payment",
        areYouSure: "Are you sure?",
        deleting: "Deleting...",
        yesDelete: "Yes, delete",
        noCancel: "No, cancel",
        cancel: "Cancel",
        infoModal: {
            id: "ID",
            firstName: "First Name",
            lastName: "Last Name",
            email: "Email",
            role: "Role",
            status: "Status",
            createdAt: "Created At",
            dateAndTime: "Date and Time",
        },
    },
};

export const paymentFormFields = [
    { key: 'action', label: 'paymentAction', type: 'dropdown', options: [{ value: 'deposit', label: 'deposit' }, { value: 'withdraw', label: 'withdraw' }, { value: 'bonus', label: 'bonus' }], editable: true, required: true },
    { key: 'assets', label: 'assets', type: 'text', editable: false },
    { key: 'amount', label: 'amount', type: 'input', dataType: 'number', editable: true, required: true, min: 0, step: '0.01' },
    { key: 'status', label: 'paymentStatus', type: 'dropdown', options: [{ value: 'success', label: 'success' }, { value: 'process', label: 'process' }, { value: 'fail', label: 'fail' }, { value: 'canceled', label: 'canceled' }, { value: 'waitaccept', label: 'waitAccept' }], editable: true, required: true },
    { key: 'bank', label: 'bank', type: 'input', editable: true, required: false },
    { key: 'wallet', label: 'wallet', type: 'input', editable: true, required: false },
    { key: 'number', label: 'accountOrCardNumber', type: 'input', editable: true, required: false },
    { key: 'comment', label: 'comment', type: 'input', editable: true, required: false },

    { key: 'id', label: 'paymentIdLocal', type: 'text', editable: false },
    { key: 'platform_id', label: 'paymentIdPlatform', type: 'text', editable: false },
    { key: 'lead_id', label: 'leadId', type: 'text', editable: false },
    { key: 'date', label: 'paymentDate', type: 'input', dataType: 'datetime-local', editable: true, required: true },
    { key: 'created_by_admin', label: 'createdByAdmin', type: 'text', editable: false },
    { key: 'created_at', label: 'recordCreationDate', type: 'text', editable: false },
    { key: 'updated_at', label: 'lastUpdateDate', type: 'text', editable: false },
];

export const getPaymentFormLabels = (lang) => {
    return labels[lang] || labels.en;
};
